module.exports = __webpack_public_path__ + "img/cover-bg.270fdd0.webp";